import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import { FaPeopleRoof } from "react-icons/fa6";
import TrainingClass from "./index";
import ViewTrainingClass from "./view";
import EditTrainingClass from "./edit";
import { MODULE_TRAINING_CLASS } from "variables/constants";
import classModuleRoutes from "./modules/routes";
import classParticipantRoutes from "./participants/routes";
import classModuleResultRoutes from "./results/routes"

const trainingClassRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Classes",
		basePath: "training-classes",
		mainComponent: <TrainingClass />,
	    layout: "/console",
		icon: <FaPeopleRoof className="icon-item" />,	   
	    subTitle:"Training Class",
	    viewComponent: <ViewTrainingClass />,
	    createComponent: <EditTrainingClass />,
	    editComponent: <EditTrainingClass />,
		level:3,
		moduleId: MODULE_TRAINING_CLASS,
		viewSubmodules: [
			...classModuleRoutes,
			...classParticipantRoutes,
			...classModuleResultRoutes
		]
	})
]

export default trainingClassRoutes;